<sim-side-panel>
  <div sidePanelHeader class="edit-panel__header">
    <div class="edit-panel__title">
      @if (icon(); as icon) {
        <sim-icon [icon]="icon" [sizeInPx]="iconSizeInPx()" color="var(--text-icon)" />
      }
      <span>{{ heading() }}</span>
    </div>
    <div class="edit-panel__header-actions">
      <ng-content select="[editPanelHeaderActions]" />
      <button sim-icon-button class="edit-panel__close" type="button" (click)="closePanel.emit()">
        <sim-icon icon="close2" [sizeInPx]="24" color="var(--text-icon)" />
      </button>
    </div>
  </div>

  <div sidePanelContent class="edit-panel__content">
    @if (loading()) {
      <div class="edit-panel__loading">
        <sim-spinner [diameter]="100" />
      </div>
    } @else {
      <ng-content />
    }
  </div>

  <div sidePanelFooter class="edit-panel__footer">
    <ng-content select="[editPanelFooter]">
      <button sim-stroked-button simColor="primary" type="button" (click)="closePanel.emit()" i18n="@@GENERAL_CANCEL">
        Cancel
      </button>
      <sim-save-button [saving]="saving()" [disabled]="!canSave() || loading()" (clicked)="save.emit()">
        {{ saveLabel() }}
      </sim-save-button>
    </ng-content>
  </div>
</sim-side-panel>
